import React from "react";

function Home2() {
    return (
        <div>
            <h1>Home2</h1>
        </div>
    );
}

export default Home2;